import { defineComponent as _defineComponent } from 'vue'
import { useRootLocale } from 'lib/helpers/useLocale'
import { computed } from 'vue'

import { vm } from '@/main'

import AuthButton from './buttons/AuthButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DemoInfo',
  setup(__props) {

const locale = computed<any>(() => ({
  demoInfo: useRootLocale('demoInfo'),
}))
const demo = computed(() => vm.$store.getters.demo)

return { __sfc: true,locale, demo, AuthButton }
}

})